import { Component, inject, Inject, PLATFORM_ID } from '@angular/core';
import { EnvService, SEOService } from "@gea-waldviertler-website/shop-lib";
import { isPlatformBrowser } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'gea-shop-homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['./homepage.component.scss'],
    standalone: false
})
export class HomepageComponent {

  pageId: number
  private envService = inject(EnvService)

  constructor(
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(SEOService) private seoService: SEOService
  ) {
    this.pageId = this.envService.config.staticCmsPages["shop-landing"]
    this.updateMetaTags()
  }

  updateMetaTags() {
    // only update Title
    if (isPlatformBrowser(this.platformId)) {
      this.titleService.setTitle("GEA Waldviertler Webshop")
      return
    }

    this.seoService.updateTitle("GEA Waldviertler Webshop")
    this.seoService.updateDescription("Entdecken Sie hochwertige, nachhaltige handgefertigte Waren bei " + 
      "den Waldviertler Werkstätten. Kaufen Sie in unserem Webshop einzigartige, " + 
      "umweltfreundliche Produkte, die ein Leben lang halten werden.")
    this.seoService.updateImage("https://gea-waldviertler.at/media/images/unspecified-3.original.jpg", "GEA Waldviertler Webshop", 1280, 853)
    this.seoService.updateType("website")
    this.seoService.updateOgUrl()
    this.seoService.updateDefaults()
  }

}
